import normalRouter from './normal'
import marketRouter from '@/router/modules/bulletinBoard/market'
import trendChartRouter from './trendChart'
import { routeAddWorkOrderId, WORK_ORDER_TYPES } from '@/views/wxapp/bulletin-board/workbench-v2/constant'
const managerRouter = [
  {
    path: 'profit-board',
    name: 'ProfitBoard',
    component: () => import('@/views/wxapp/bulletin-board/profit-board'),
    meta: {
      title: '利润看板'
    }
  },
  {
    path: 'ranking-list',
    name: 'DepartmentKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'ranking-list',
        name: 'RankingList',
        component: () => import('@/views/wxapp/bulletin-board/ranking-list/index'),
        meta: {
          title: 'B2C净利排名'
        }
      },
      {
        path: 'detailed-list',
        name: 'DetailedList',
        component: () => import('@/views/wxapp/bulletin-board/ranking-list/detailed-list'),
        meta: {
          title: '营收排名'
        }
      },
      {
        path: 'partner',
        name: 'Partner',
        component: () => import('@/views/wxapp/bulletin-board/partner/index'),
        meta: {
          title: '城市合伙人'
        }
      }
    ]
  },

  {
    path: 'area-list',
    name: 'AreaDepartmentKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'area-board',
        name: 'AreaBoard',
        component: () => import('@/views/wxapp/bulletin-board/area-board'),
        meta: {
          title: ''
        }
      },
      {
        path: 'area-details',
        name: 'AreaDetails',
        component: () => import('@/views/wxapp/bulletin-board/area-board/area-details'),
        meta: {
          title: ''
        }
      }
    ]
  },

  {
    path: 'division-list',
    name: 'DivisionDepartmentKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'division',
        name: 'Division',
        component: () => import('@/views/wxapp/bulletin-board/division'),
        meta: {
          title: ''
        }
      },
      {
        path: 'division-details',
        name: 'DivisionDetails',
        component: () => import('@/views/wxapp/bulletin-board/division/division-details'),
        meta: {
          title: '高新事业部利润看板'
        }
      }
    ]
  },

  {
    path: 'shop-list',
    name: 'ShopDepartmentKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'shop-manager',
        name: 'ShopManager',
        component: () => import('@/views/wxapp/bulletin-board/shop-manager/index'),
        meta: {
          title: ''
        }
      },
      {
        path: 'board-details',
        name: 'BoardDetails',
        component: () => import('@/views/wxapp/bulletin-board/shop-manager/board-details/index'),
        meta: {
          title: ''
        }
      },
      {
        path: 'income-details',
        name: 'IncomeDetails',
        component: () => import('@/views/wxapp/bulletin-board/shop-manager/board-details/income-details'),
        meta: {}
      }
    ]
  },

  {
    path: 'charge-list',
    name: 'ChargeDivisionKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'charge-division',
        name: 'ChargeDivision',
        component: () => import('@/views/wxapp/bulletin-board/charge-division/index'),
        meta: {
          title: '事业一部负责人看板'
        }
      },
      {
        path: 'charge-details',
        name: 'ChargeDetails',
        component: () => import('@/views/wxapp/bulletin-board/charge-division/charge-details/index'),
        meta: {
          title: ''
        }
      }
    ]
  },

  {
    path: 'manage-tab',
    name: 'ManageTab',
    component: () => import('@/views/wxapp/bulletin-board/manage-tab/index'),
    meta: {
      title: '经营看板入口'
    }
  },

  ...normalRouter,
  ...marketRouter,
  ...trendChartRouter
]

export default routeAddWorkOrderId(managerRouter, WORK_ORDER_TYPES.OPERATE)
